import React, { useState, useEffect } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import numeral from "numeral"

const FloorplanAnalysis = (props) => {
	//? THIS IS ACTUAL
	let ret = {}
	let f = []
	/* _.forEach(props.payload.public.floorplans, v => {
		_.forEach(v.lot_types, (v2, k2) => {
			if(_.intersection(props.activeProperties, v.properties).length === 0) return
			let path = `${v.id}.${v2.lot_type}`
			if(!_.has(ret, path)) {
				_.setWith(
					ret,
					path,
					{
						builder: v.builder,
						name: v.name,
						lot_type: v2.lot_type,
						floorplan_id: v.id,
						sqft: v.sqft,
						base_price: v2.manual_base_price || v2.base_price,
						avg_closing_price: 0,
						gross_count: 0,
						gross_closing_amount: 0,
					},
					Object
				)
			}
		})
	}) */
	_.forEach(props.payload.closings.current, (v) => {
		if (!v.closing_price) return
		let path = `${v.floorplan}.${v.lot_type}`
		if (!_.has(ret, path)) {
			let fp = _.find(props.payload.public.floorplans, { id: v.floorplan })
			let base = v.floorplan_base_price
			if(fp && Array.isArray(fp.lot_types) && fp.lot_types.length > 0) {
				let check = _.find(fp.lot_types, { lot_type: v.lot_type, property: v.property })
				if(check) {
					base = check.manual_base_price || check.base_price
				}
			}
			if(!base) base = 0
			_.setWith(
				ret,
				path,
				{
					builder: v.builder,
					name: fp?.name || null,
					lot_type: v.lot_type,
					floorplan_id: v.floorplan,
					sqft: v.sqft,
					base_price: base,
					avg_closing_price: 0,
					gross_count: 0,
					gross_closing_amount: 0,
					base_v_closing: v.closing_price - base,
				},
				Object
			)
		}
		ret[v.floorplan][v.lot_type].gross_count++
		ret[v.floorplan][v.lot_type].gross_closing_amount += v.closing_price
	})
	_.forEach(ret, (v1, fp) => {
		_.forEach(v1, (v2, lt) => {
			if (v2.gross_count > 0) {
				ret[fp][lt].avg_closing_price = v2.gross_closing_amount / v2.gross_count
			}
		})
	})
	_.forEach(ret, (v1, fp) => {
		_.forEach(v1, (v2, lt) => {
			let type = _.find(props.payload.public.lot_types, { id: parseInt(lt) })
			let builder = _.find(props.payload.public.builders, { id: parseInt(v2.builder) })
			v2.lot_type = type?.name || ""
			v2.builder = builder?.name || ""
			if(!v2.base_price) {
				v2.base_price = null
				v2.base_v_closing = null
			}
			f.push(v2)
		})
	})
	//console.log(ret)
	const columns = [
		{
			Header: "Builder",
			accessor: "builder",
			className: "small",
			filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
		},
		{
			Header: "Floorplan Name",
			accessor: "name",
			className: "small",
			filterMethod: (f, r) => helpers.tableText(f, r, "name"),
		},
		{
			Header: "Lot Type",
			accessor: "lot_type",
			className: "small",
			filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
		},
		{
			Header: "Square Footage",
			accessor: "sqft",
			Cell: (props) => numeral(props.value).format("0,0"),
			Footer: (props) => helpers.tableAverages(props, "sqft", "0,0"),
		},
		{
			Header: "Num Closings",
			accessor: "gross_count",
			Cell: (props) => numeral(props.value).format("0,0"),
			sort: "desc",
			headerClassName: "wrap small",
			Footer: (props) => helpers.tableTotals(props, "gross_count", "0,0"),
		},
		{
			Header: "Base Price",
			accessor: "base_price",
			Cell: (props) => numeral(props.value).format("$0,0"),
			sort: "desc",
			headerClassName: "wrap small",
			Footer: (props) => helpers.tableAverages(props, "base_price", "$0,0"),
		},
		{
			Header: "Average Closing Price",
			accessor: "avg_closing_price",
			Cell: (props) => numeral(props.value).format("$0,0"),
			Footer: (props) => helpers.tableAverages(props, "avg_closing_price", "$0,0"),
		},
		{
			Header: "Avg Closing vs Base Difference",
			accessor: "base_v_closing",
			Cell: (props) => numeral(props.value).format("$0,0"),
			Footer: (props) => helpers.tableAverages(props, "base_v_closing", "$0,0"),
		},
	]

	return (
		<>
			<h3>Floorplan Closing Analysis</h3>
			<div>
				<FullTable data={f} columns={columns} name="salesSummary__summary" classNames="small" title="Summary" />
			</div>
		</>
	)
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(FloorplanAnalysis)
